import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default function Index({ data }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);
  useEffect(() => {
    if (data?.length) {
      const parityData = {
        datasets: [
          {
            data: data?.map((item) => item.count) || [],
            backgroundColor: data?.map((item) => item.backgroundColor),
            hoverOffset: 4
          }
        ],
        labels: data.map(({type, count, percentValue }) => `${type} : ${count} (${percentValue}%)`) || [],
      };

      setGraphData(parityData);
    }
  }, [data]);



  const sortedLegends = data
    ?.map(({ type, backgroundColor }) => ({
      name: t(type),
      backgroundColor
    }))
    .sort(({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
    );
  const customOptions = {
      tooltips: {
        enabled:false,
        custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
      },
    };
  return (
    <Graph
        graphData={graphData}
        legends={sortedLegends}
        title={t("Raisons de départ")}
        spaceLegende="arh-space-y-2"
        customOptions={customOptions}
        chartRef={chartRef} 
    />
  );
}
